
import React, { useState } from 'react';
import './TableViewDoc.css';

function TableViewDoc({ data = [], columns = [], onView }) {
  


  if (!data.length) {
    return <div>No data available</div>; // Handle empty data
  }

  return (
    <div className="table-view-doc">
      {/* Display the column headers */}
      <ul className="table-header">
        {columns.map((col, index) => (
          <li key={index} className="header-item">
            {col}
          </li>
        ))}
        <li className="header-item">Action</li> {/* Add Action column */}
      </ul>

      {/* Display the rows */}
      <div className="table-body">
        {data.map((row, index) => (
          <ul key={index} className="table-row">
            <li className="row-item">{row.device_id}</li>
            <li className="row-item">{row.patient_message}</li>
            <li className="row-item">
              {/* Action button */}
              <button
                className="view-button"
                onClick={() => onView(row.device_id)} // Handle the view button action
              >
                View
              </button>
            </li>
          </ul>
        ))}
      </div>
      <div>
       
      </div>
    </div>
  );
}

export default TableViewDoc;


